import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { TandemLink } from 'library';

export default function CenterMenu({
    isMenuOpen,
    handleMenuClose,
    anchorRef,
}: {
    isMenuOpen: boolean;
    handleMenuClose: () => void;
    anchorRef: React.RefObject<HTMLDivElement> | null;
}) {
    return (
        <Menu
            anchorEl={anchorRef?.current}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            sx={{
                borderRadius: 18,
            }}
        >
            <MenuItem>
                <TandemLink to="/how-it-works" onClick={handleMenuClose}>
                    How It Works
                </TandemLink>
            </MenuItem>
            <MenuItem>
                <TandemLink to="/daycare-trial-runs" onClick={handleMenuClose}>
                    Permanent Hires
                </TandemLink>
            </MenuItem>
            <MenuItem>
                <TandemLink to="/daycare-substitutes" onClick={handleMenuClose}>
                    Temporary Staff
                </TandemLink>
            </MenuItem>
        </Menu>
    );
}
